// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TagAuthorizeSvg from '@rsuite/icon-font/lib/application/TagAuthorize';
var TagAuthorize = createSvgIcon({
  as: TagAuthorizeSvg,
  ariaLabel: 'tag authorize',
  category: 'application',
  displayName: 'TagAuthorize'
});
export default TagAuthorize;